import { usingPost } from '@ocean/api'
import { EventCreatorFormParams } from 'modules/virtualClassrooms/manager/EventCreator/types'

export const createVirtualClassroomEvent = (params: EventCreatorFormParams) =>
  usingPost('VirtualEvents/AddVirtualEvent', params)

export const publishVirtualClassroomEvent = (eventId: Guid) =>
  usingPost('VirtualEvents/PublishVirtualEvent', { eventId })
